/*
 * This module is for TDV events.
 * To start tracking you will need to the following data attribute
 * data-builder='builder id value'
 * data-community='community id value'
 * data-parent-community-id='parent community id value'
 * data-community-list='list id of communities value'
 * data-market='market id value'
 * data-plan-id='plan id value'
 * data-spec-id='spec id value'
 * data-basic-listing-id='basic listing id value'
 * data-refer='refer value'
 * data-totalHomes='totalHomes value'
 * data-builder-community-list='BuilderId CommunityId ParentCommunityId MarketId,'
 * data-basic-listing-list='BuilderId ListingId,'
 * data-home-list='homeId (s||p),'
 */

(function tdvTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};
  const isBasic = document.getElementById('IsBasic');
  const previousModule = global.NewHomeSource.Analytics.TdvTracker;
  const inputSiteRoot = document.querySelector('#nhs_siteRootLogger');
  const siteRoot = (inputSiteRoot && inputSiteRoot.value) || '/';
  const baseUrl = siteRoot + 'eventlogger/logevent-[EventCode]';
  const googleEcommercePushUrl = '/googleanalytics/getgoogleecommercepush';
  const paramsEventLogger = ['builder', 'community', 'parentCommunityId', 'market', 'planId', 'specId',
    'basicListingId', 'refer', 'totalHomes'];
  const parametersEventMapper = {
    communityId: 'community',
    marketId: 'market'
  };
  const paramsByQueryString = ['communityList', 'builderCommunityList', 'basicListingList', 'homeList',
    'homeImpression'];
  const basicListingParameters = ['market', 'basicListingId', 'basicListingList'];
  const configurations = {
    eventPrefix: 'data-tdv-event-label',
    impressionPrefix: 'data-tdv-impression-label',
    isBasic: isBasic && isBasic.value === 'True'
  };

  function getBasicListingParameters(parameters) {
    const basicParams = [];
    basicListingParameters.forEach((param) => {
      if (parameters[param] && parameters[param] !== '0') {
        basicParams[param] = parameters[param];
      }
    });

    return basicParams;
  }

  function getParamsToUse(parameters) {
    return parameters.isBasicListing === 'true' ? getBasicListingParameters(parameters) : parameters;
  }

  /**
   * @private
   * Gets rthe correct naming for the TDV events.
   * @returns The correct TDV parameter name.
   */
  function getTdvAttributeName(datasetAttributeName) {
    const tdvParameter = parametersEventMapper[datasetAttributeName] || datasetAttributeName;
    return tdvParameter;
  }

  /**
   * @private
   * createUrl: create the url with the parameters reviced, it will match with keys of urls object
   * with the keys of dataset of the element.
   *
   * @param {String} url base url to be requested.
   * @param {Array} parameters that match with urls object keys and use the value to replace [Id].
   * @returns the url to be requested for logging.
   */
  function createUrl(url, parameters) {
    let getUrl = url;
    let parameterSeparator = '?';
    const keysParameters = Object.keys(getParamsToUse(parameters));
    for (let index = 0; index < keysParameters.length; index += 1) {
      const parameter = keysParameters[index];
      const cleanParameter = parameter.replaceAll('-', '').toLowerCase();
      const cleanParamsEventLogger = paramsEventLogger.map((value) => value.toLowerCase());
      const position = cleanParamsEventLogger.indexOf(cleanParameter);
      if (position > -1 && parameters[parameter] && parameters[parameter] !== '0') {
        getUrl += '/' + paramsEventLogger[position] + '-' + parameters[parameter];
      }
    }

    getUrl += '/GAClientId-' + configurations.data.googleAnalyticsClientId.getValue(true) +
    '/GAUserId-' + configurations.data.googleAnalyticsUserId.getValue(true);

    keysParameters.forEach((parameter) => {
      const cleanParameter = parameter.replaceAll('-', '').toLowerCase();
      const cleanParamsEventLogger = paramsByQueryString.map((value) => value.toLowerCase());
      const position = cleanParamsEventLogger.indexOf(cleanParameter);
      if (position > -1 && parameters[parameter] && parameters[parameter] !== '0') {
        getUrl += parameterSeparator + paramsByQueryString[position] + '=' + parameters[parameter];
        parameterSeparator = '&';
      }
    });

    return getUrl;
  }

  /**
   * @private
   * postRequest: to create an HTTP Post request to send data.
   *
   * @param {String} url to be requested.
   * @param {Object} data with the information to log.
   * @param {Function} successCallback to be executed on request is success.
   */
  function postRequest(url, data, successCallback) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));

    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) {
        return;
      }

      if (xhr.status === 200) {
        if (typeof successCallback === 'function') {
          successCallback(xhr.response);
        }
      }
    };
  }

  /**
   * @private
   * logGoogleEcommerceEvent: log google ecommerce event and execute in datalayer.
   *
   * @param {String} eventName event to be logged on analytics
   * @param {Array} parameters data used to get the information from the page.
   */
  function logGoogleEcommerceEvent(eventName, parameters) {
    const isMpc = parameters.parentCommunity !== 0;
    const params = {
      eventName,
      communityId: parameters.community,
      specId: parameters.spec,
      planId: parameters.plan,
      builderName: parameters.builderName || '',
      communitiesIdsList: parameters.buildercommunitylist,
      homesIdsList: parameters.homeList,
      isMpc
    };
    postRequest(googleEcommercePushUrl, params, (result) => {
      // The GetDataLayerPush method of the Google Analytics Controller returns a js that needs to be executed
      // eslint-disable-next-line no-eval
      eval(result);
    });
  }

  /**
   * @private
   * logEvent: log event related to TDV.
   *
   * @param {String} eventCode that will be tracker.
   * @param {Array} parameters that will be add on the url to track.
   */
  function logEvent(eventCode, parameters) {
    if (eventCode) {
      const url = baseUrl.replace('[EventCode]', eventCode);
      const urlToRequest = createUrl(url, parameters);
      logGoogleEcommerceEvent(eventCode, parameters);
      postRequest(urlToRequest);
    }
  }

  /**
   * @private
   *
   * Checks if the parent community id belongs to a MPC that was already visited.
   * @param {number} parentCommunityId
   * @returns The same parent community id if the MPC was visited, 0 otherwise.
   */
  function getValidParentCommunityId(parentCommunityId) {
    if (parentCommunityId === 0) {
      return 0;
    }

    const isVisitedMpc = configurations.data.visitedMpcIds();

    if (!isVisitedMpc || isVisitedMpc.indexOf(parentCommunityId) === -1) {
      return 0;
    }

    return parentCommunityId;
  }

  /**
   * @constructs NewHomeSource.Analytics.TdvTracker
   */
  function TdvTracker(globalValues) {
    configurations.data = globalValues;
  }

  /**
   * Gets the dataset information to be used for loggin the TDV Events.
   * @param {HTMLElement} eventTarget Element where the event was triggered.
   * @returns An object with the dataset to be used on the TDV events.
   */
  function getTdvEventDataset(eventTarget) {
    const parentTdvContainer = eventTarget.closest('[data-tdv-container]');
    const parentTdvDataset = parentTdvContainer ? parentTdvContainer.dataset : {};
    const mergedDataset = { ...parentTdvDataset, ...eventTarget.dataset };
    mergedDataset.parentCommunity = getValidParentCommunityId(eventTarget.dataset.parentCommunity);

    const datasetAttributesList = Object.entries(mergedDataset);
    const tdvEventDatasetAttributesList = datasetAttributesList.map(([name, value]) => {
      const tdvAttributeName = getTdvAttributeName(name);

      return [tdvAttributeName, value];
    });
    const tdvEventDataset = Object.fromEntries(tdvEventDatasetAttributesList);

    return tdvEventDataset;
  }

  /**
   * @public
   * eventTracker: send data related to user action events.
  */
  TdvTracker.eventTracker = function eventTracker() {
    const eventLabel = this.getAttribute(configurations.eventPrefix).split(',');

    if (!eventLabel) {
      return true;
    }

    const tdvDataset = getTdvEventDataset(this);
    eventLabel.forEach((event) => {
      logEvent(event, tdvDataset);
    });

    return true;
  };

  /**
 * @public
 * impressionTracker: send data related to display events.
 */
  TdvTracker.impressionTracker = function impressionTracker() {
    for (let index = 0; index < this.length; index += 1) {
      const eventLabel = this[index].getAttribute(configurations.impressionPrefix).split(',');

      if (!eventLabel) {
        return true;
      }

      const tdvDataset = getTdvEventDataset(this[index]);
      eventLabel.forEach((event) => {
        logEvent(event, tdvDataset);
      });
    }

    return true;
  };

  /**
   * @public
   * eventTrackerValidator: validates if the dataset passed as parameter represents a segment event being tracked.
   */
  TdvTracker.eventTrackerValidator = function eventTrackerValidator(dataset) {
    if (dataset.tdvEventLabel) {
      return true;
    }

    return false;
  };

  /**
   * @public
   * onDemandTrackerValidator: validates if the dataset passed as parameter represents a segment event being tracked.
   */
  TdvTracker.onDemandTrackerValidator = function eventTrackerValidator(data) {
    return data && data.eventType === 'tdvEvent';
  };

  /**
  * @public
  * onDemandTracker: send data related to events that cannot be mapped to the HTML.
  *
  * @param {object} status of the scheduled idle task.
  */
  TdvTracker.onDemandTracker = function onDemandTracker() {
    const label = this.label;

    if (!label) {
      return true;
    }

    this.parentCommunity = getValidParentCommunityId(this.parentCommunity);
    logEvent(label, this);

    return true;
  };
  /**
  * @public
  * impressionTrackerSelector: returns the expression that can be used to query the DOM.
  */
  TdvTracker.impressionTrackerSelector = function impressionTrackerSelector() {
    return configurations.impressionPrefix;
  };

  TdvTracker.identityTracker = function identityTracker() {
    const elementIdentity = this.form.querySelector('[data-tdv-identity]');

    if (!elementIdentity) {
      return true;
    }

    const data = elementIdentity.dataset;

    if (!data.eventCode) {
      return true;
    }

    data.parentCommunity = getValidParentCommunityId(data.parentCommunity);
    logEvent(data.eventCode, data);

    return true;
  };

  /**
   * @public
   * identityTrackerValidator: validates if the dataset passed as parameter represents a segment identity being tracked.
   */
  TdvTracker.identityTrackerValidator = function identityTrackerValidator(dataset) {
    return !!dataset.tdvIdentity;
  };

  TdvTracker.buildTagWithEvent = function (element, event, attributes) {
    element.setAttribute('data-event', 'true');
    element.setAttribute('data-tdv-event-label', event);
    attributes.forEach((attr) => {
      element.setAttribute(attr.name, attr.value);
    });
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Segment to the previous script.
   */
  TdvTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.TdvTracker = previousModule;
    return TdvTracker;
  };

  global.NewHomeSource.Analytics.TdvTracker = TdvTracker;
}(window));
